import { db } from "../../config/firebaseconfig";
import timestamper from "../timestamper";

export default function logLogin(userId, role) {
  let collection = 'students'
  if (role !== 'Student') {
    collection = 'educators'
  }
  db.collection(collection).doc(userId).get()
    .then((userDoc) => {
      const user = userDoc.data()
      let updateVal, updateKey
      if (user.activity) {
        if (user.activity.login) {
          updateKey = 'activity.login'
          updateVal = {
              ...user.activity.login,
              [timestamper()]: true,
            }
        } else {
          updateKey = 'activity'
          updateVal = {
            ...user.activity,
            login: {
              [timestamper()]: true,
            }
          }
        }
      } else {
        updateKey = 'activity'
        updateVal = {
          login: {
            [timestamper()]: true,
          }
        }
      }
      return db.collection(collection).doc(user.id).update({
        [updateKey]: updateVal
      })
    })
    .catch((err) => console.log(err))
}


// WEBPACK FOOTER //
// ./src/helpers/users/logLogin.js